module.exports = __webpack_public_path__ + "static/img/extracciones-domicilio.83afc1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/extracciones-domicilio.jpg
// module id = yQAr
// module chunks = 1